import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import AsyncProductSelect from '../../Shared/AsyncProductSelect'
import NumberFormat from 'react-number-format'
import measurementTypes from '../../../_constants/measurementTypes'
import ConvertQuantity from '../../Shared/ConvertQuantity'

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  taskType
}) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <fieldset className="fieldset">
        <legend>اطلاعات کالا جهت تولید</legend>

        <div className="row">
          <div className="form-inline">
            <div className="col-md-4 col-sm-12">
              <label>دسته بندی</label>
              <AsyncCategorySelect
                categoryType={parseInt(taskType, 0) === 0 ? 0 : 2}
                defaultValue={values.categoryId}
                name="categoryId"
                onChange={(val, measurementType) => {
                  // console.log(val);

                  setFieldValue('categoryId', val)
                  setFieldValue('productId', undefined)
                  setFieldValue('product', undefined)
                  setFieldValue('quantity', '')
                  setFieldValue('subQuantity', '')
                }}
                className={
                  getIn(touched, 'categoryId')
                    ? getIn(errors, 'categoryId')
                      ? 'semantic-select-box has-error'
                      : 'semantic-select-box'
                    : 'semantic-select-box has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="categoryId" />
            </div>

            <div className="col-md-4 col-sm-12">
              <label>برند</label>
              <AsyncBrandSelect
                brandType={parseInt(taskType, 0) === 0 ? 0 : 1}
                defaultValue={values.brandId}
                name="brandId"
                onChange={val => {
                  // console.log(val);

                  setFieldValue('brandId', val)
                  setFieldValue('productId', undefined)
                  setFieldValue('product', undefined)
                  setFieldValue('quantity', '')
                  setFieldValue('subQuantity', '')
                }}
                className={
                  getIn(touched, 'brandId')
                    ? getIn(errors, 'brandId')
                      ? 'semantic-select-box has-error'
                      : 'semantic-select-box'
                    : 'semantic-select-box has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="brandId" />
            </div>

            <div className="col-md-4 col-sm-12">
              <label>نام کالا</label>
              <AsyncProductSelect
                brandId={values.brandId}
                categoryId={values.categoryId}
                defaultValue={values.productId}
                name="productId"
                onChange={(val, measurementType) => {
                  // console.log(val);

                  setFieldValue('productId', val.value)
                  setFieldValue('product', val)
                  setFieldValue('quantity', '')
                  setFieldValue('subQuantity', '')
                }}
                className={
                  getIn(touched, 'productId')
                    ? getIn(errors, 'productId')
                      ? 'semantic-select-box has-error'
                      : 'semantic-select-box'
                    : 'semantic-select-box has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="productId" />
            </div>

            <div className="clearfix" />

            {/* <div className="col-md-6 col-sm-12">
              <label>
                میزان سفارش{' '}
                {values &&
                values.product &&
                values.product.measurementType != undefined
                  ? '(' +
                    measurementTypes.filter(
                      el => el.value === values.product.measurementType
                    )[0].label +
                    ')'
                  : ''}
              </label>
              <NumberFormat
                isNumericString
                allowNegative={false}
                disabled={!values.productId}
                defaultValue={values.quantity}
                value={values.quantity}
                name="quantity"
                onChange={e => {
                  let q = e.target.value
                  setFieldValue('quantity', q)

                  if (q) {
                    // let subQuantity = Math.round(q / values.product.conversionUnit)
                    let subQuantity = ConvertQuantity(
                      q,
                      values.product.conversionUnit,
                      3,
                      2
                    )
                    setFieldValue('subQuantity', subQuantity)
                  } else {
                    setFieldValue('subQuantity', undefined)
                  }
                }}
                onBlur={handleBlur}
                className={
                  getIn(touched, 'quantity')
                    ? getIn(errors, 'quantity')
                      ? 'text-input has-error'
                      : 'text-input'
                    : 'text-input has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="quantity" />
            </div>

            <div className="col-md-6 col-sm-12">
              <label>
                میزان سفارش{' '}
                {values &&
                values.product &&
                values.product.subMeasurementType != undefined
                  ? '(' +
                    measurementTypes.filter(
                      el => el.value === values.product.subMeasurementType
                    )[0].label +
                    ')'
                  : ''}
              </label>
              <NumberFormat
                isNumericString
                allowNegative={false}
                disabled={!values.productId}
                defaultValue={values.subQuantity}
                value={values.subQuantity}
                name="subQuantity"
                onChange={e => {
                  let q = e.target.value
                  setFieldValue('subQuantity', q)

                  if (q) {
                    let quantity = ConvertQuantity(
                      q,
                      values.product.conversionUnit,
                      3,
                      1
                    )
                    // let quantity = (q * values.product.conversionUnit)
                    setFieldValue('quantity', quantity)
                  } else {
                    setFieldValue('quantity', undefined)
                  }
                }}
                onBlur={handleBlur}
                className={
                  getIn(touched, 'subQuantity')
                    ? getIn(errors, 'subQuantity')
                      ? 'text-input has-error'
                      : 'text-input'
                    : 'text-input has-error'
                }
              />
              <ErrorMessage component={ErrorPopUp} name="subQuantity" />
            </div>

            <div className="clearfix" /> */}

            <div className="col-md-12 col-sm-12">
              <label>توضیحات</label>
              <Field
                name="description"
                rows="2"
                render={({ field }) => (
                  <textarea
                    {...field}
                    value={values.description || ''}
                    className="textarea rtl"
                  />
                )}
              />
              <ErrorMessage component={ErrorPopUp} name="description" />
            </div>

            <div className="clearfix" />
          </div>
        </div>
      </fieldset>
    </div>
  </div>
)
